export const FADE_TRANSITION_TIMEOUT_MILLISECONDS = 450;